import { googleLogout } from "@react-oauth/google";
import { ChevronDown, ChevronRight, Folder, LogOut, Settings, User } from "lucide-react";
import { Link } from "react-router-dom";

import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "../../../../components/ui/dropdown-menu";
import { useAuth } from "../../../../context/Auth/AuthContext";

const Header = () => {
	const { isLoggedIn, logout, userData } = useAuth();

	const { firstName, email } = userData ? userData : { firstName: "", email: "" };

	const isDropzOpsUser = Boolean(userData?.isDropzOpsUser);

	return (
		<div className="flex h-[100px] w-full items-center justify-between">
			<div className="w-1/2">
				<p className="ml-5 text-xs font-medium text-gray-500">
					{firstName ? `Welcome, ${firstName}` : "Welcome, there's a lot to explore!"}
				</p>
			</div>

			<div className="flex flex-1 justify-end">
				<DropdownMenu>
					<DropdownMenuTrigger className="flex items-center gap-1 text-sm text-gray-900 outline-hidden">
						<div className="flex w-[180px] items-center justify-center">
							<User className="mr-2 h-3.5 w-3.5 text-blue-700" />
							<p className="mr-2 text-[10px] font-medium text-gray-500">My Account</p>
							<ChevronDown className="h-3 w-3" />
						</div>
					</DropdownMenuTrigger>

					<DropdownMenuContent align="end" className="w-[180px] rounded border p-1 shadow-xs">
						<div className="flex items-center gap-2 px-2 py-1.5">
							<i className="fa fa-user text-gray-500" />
							<div>
								<p className="m-0 text-xs font-medium">{firstName || "My Account"}</p>
								<p className="m-0 text-[10px] text-gray-500">{email.substr(0, 14) + "..."}</p>
							</div>
							<ChevronRight className="ml-auto h-3 w-3 text-blue-700" />
						</div>

						<DropdownMenuItem asChild>
							<Link to="/jobs" className="flex items-center gap-2 text-xs text-gray-900">
								<Folder className="h-3.5 w-3.5 text-gray-400" />
								Jobs
							</Link>
						</DropdownMenuItem>

						{isLoggedIn ? (
							<>
								<DropdownMenuItem asChild className="border-t">
									<Link to="/jobs-preference" className="flex items-center gap-2 text-xs text-gray-900">
										<Settings className="h-3.5 w-3.5 text-gray-400" />
										Job Preferences
									</Link>
								</DropdownMenuItem>
								{isDropzOpsUser && (
									<DropdownMenuItem asChild className="border-t">
										<Link to="/job-market" className="flex items-center gap-2 text-xs text-gray-900">
											<i className="bi bi-person-fill-gear text-gray-400" />
											Control Center
										</Link>
									</DropdownMenuItem>
								)}
								<DropdownMenuItem asChild className="border-t">
									<Link
										to="/signin"
										className="flex items-center gap-2 text-xs text-gray-900"
										onClick={() => {
											logout();
											googleLogout();
										}}
									>
										<LogOut className="h-3.5 w-3.5 text-gray-400" />
										Log Out
									</Link>
								</DropdownMenuItem>
							</>
						) : (
							<DropdownMenuItem asChild>
								<Link to="/register" className="text-xs">
									Register
								</Link>
							</DropdownMenuItem>
						)}
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
		</div>
	);
};

export default Header;
